import React from 'react';
import { Outlet } from 'react-router-dom';
import { NavbarBlack } from '../NavbarBlack/NavbarBlack';
import { Footer } from '../Footer/Footer';

/**
 * WrapperBlack
 * @description: Wrapper de la aplicación Black
 * @returns JSX del Screen.
 */
export const WrapperBlack: React.FC = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <NavbarBlack />
      <main style={{ flex: 1 }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
